import AdminVoteOptionsContainer from './AdminVoteOptionsContainer';

export default AdminVoteOptionsContainer;
